import React from 'react'
import { useSelector } from 'react-redux'
import { Checkbox, FormControlLabel, Typography } from '@material-ui/core'
import { useFormikContext } from 'formik'

import { SectionBlock } from '../SectionBlock'

import { useStyles } from './CategoriesSection.style'

const CategoriesSection = () => {
  const classes = useStyles()

  const { values, setFieldValue, errors, touched, handleBlur } = useFormikContext()
  const { eventCircuitCategoryResults } = useSelector((state) => state.championships)

  const categoryOptions = eventCircuitCategoryResults.categories
    ?.filter((x) => x.events.some((e) => values.events.some((d) => d.id === e.eventId)))
    .filter((x) =>
      x.distances.some(
        (d) =>
          !values.excludedDistances ||
          !values.excludedDistances[d.name] ||
          !values.excludedDistances[d.name].checked
      )
    )
    .sort((a, b) => a.name.toLowerCase().trim().localeCompare(b.name.trim().toLowerCase()))

  return (
    <SectionBlock title='Categorías'>
      <div className={classes.container}>
        {categoryOptions?.map((c, index) => (
          <FormControlLabel
            key={c.name}
            control={
              <Checkbox
                color='primary'
                name='excludedCategories'
                className={classes.checkbox}
                onBlur={handleBlur}
                checked={!values.excludedCategories[c.name]?.checked}
                onChange={(e) =>
                  setFieldValue(`excludedCategories`, {
                    ...values.excludedCategories,
                    [c.name]: { name: c.name, checked: !e.target.checked }
                  })
                }
              />
            }
            label={
              <Typography variant='h6' color='primary' className={classes.checkMiniLabel}>
                {c.name}
              </Typography>
            }
          />
        ))}

        {errors.excludedCategories && (
          <Typography
            variant='caption'
            color={touched.excludedCategories ? 'error' : 'inherit'}
            className={classes.altErrorMessage}>
            {errors.excludedCategories}
          </Typography>
        )}
      </div>
    </SectionBlock>
  )
}

export default CategoriesSection
